class OwnershipVideoModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.ownership-section__video-modal');
    this.closeButton = this.querySelector('.ownership-section__video-close');
    this.videoButton = this.querySelector('.ownership-section__video-btn');
    this.videoIframe = this.querySelector('#ownership-video');
    this.videoElement = this.querySelector('.ownership-section__video-modal-content video');
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.body = document.querySelector('body');
  }

  connectedCallback() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    if (this.videoButton) {
      this.videoButton.addEventListener('click', this.openModal.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.closeModal.bind(this));
    }

    if (this.videoButton) {
      this.videoButton.removeEventListener('click', this.openModal.bind(this));
    }

    window.removeEventListener('click', this.handleOutsideClick);
  }

  openModal() {
    if (this.modal) {
      this.modal.style.display = 'block';
      this.body.style.overflow = 'hidden';
      window.addEventListener('click', this.handleOutsideClick);
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.style.display = 'none';
      this.pauseVideo();
      this.body.style.overflow = 'auto';
      window.removeEventListener('click', this.handleOutsideClick);
    }
  }

  handleOutsideClick(event) {
    if (event.target === this.modal) {
      this.closeModal();
    }
  }

  pauseVideo() {
    // If using an iframe (e.g., YouTube, Vimeo)
    if (this.videoIframe) {
      const src = this.videoIframe.getAttribute('src');
      this.videoIframe.setAttribute('src', '');
      this.videoIframe.setAttribute('src', src);
    }

    // If using a native HTML5 video element
    if (this.videoElement) {
      this.videoElement.pause();
      this.videoElement.currentTime = 0;
    }
  }
}

customElements.define('ownership-video-modal', OwnershipVideoModal);